import React from 'react';

const NewChangeLog = () => <div />;

export default NewChangeLog;
